import { ApiService } from './apiService';
import { API_ENDPOINTS } from '../config/api';
import {
  AdminConnectionCard,
  ConnectionsTab,
} from '../types/connection';

export class ConnectionService extends ApiService {
  async getConnections(
    clientUserId: string,
    tab: ConnectionsTab
  ): Promise<AdminConnectionCard[]> {
    return this.get<AdminConnectionCard[]>(
      API_ENDPOINTS.users.connections(clientUserId, tab)
    );
  }

  async getConnectionsTabTotal(clientUserId: string): Promise<number> {
    const tabs: ConnectionsTab[] = ['received', 'accepted', 'pending', 'rejected'];
    const results = await Promise.all(
      tabs.map(tab => this.getConnections(clientUserId, tab).catch(() => []))
    );
    return results.reduce((sum, rows) => sum + rows.length, 0);
  }
}

export const connectionService = new ConnectionService();

export const formatConnectionDetail = (
  age: number | null,
  height: string | null
): string => {
  const parts: string[] = [];
  if (age != null) parts.push(`${age} Yrs`);
  if (height) parts.push(height);
  return parts.length > 0 ? parts.join(', ') : '—';
};
